"use client";

import * as React from "react";
import { Text, SectionCard, CardTitle, CardDescription, Section, Progress } from "@/src/components";
import { InstallCommand } from "@/components/docs/install-command";

export default function DocsComponentsProgress() {
  const [progress, setProgress] = React.useState(33);

  React.useEffect(() => {
    const timer = setTimeout(() => setProgress(66), 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <Section>
        <div className="space-y-4">
          <Text as="h1" className="text-h2 font-bold">
            Progress
          </Text>
          <Text className="text-lg text-muted-foreground max-w-2xl">
            Displays an indicator showing the completion progress of a task.
          </Text>
        </div>
      </Section>

      {/* Installation */}
      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Installation</CardTitle>
              <CardDescription>Add this component to your project</CardDescription>
            </>
          }
          contentClassName="p-6"
        >
          <InstallCommand command="npx shadcn@latest add @bluecopa-ui/progress" />
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={
            <>
              <CardTitle>Example</CardTitle>
              <CardDescription>Progress bars at different values</CardDescription>
            </>
          }
          contentClassName="p-6 space-y-6"
        >
          <div className="space-y-2">
            <Text className="text-sm">25% Complete</Text>
            <Progress value={25} />
          </div>
          <div className="space-y-2">
            <Text className="text-sm">50% Complete</Text>
            <Progress value={50} />
          </div>
          <div className="space-y-2">
            <Text className="text-sm">75% Complete</Text>
            <Progress value={75} />
          </div>
          <div className="space-y-2">
            <Text className="text-sm">100% Complete</Text>
            <Progress value={100} />
          </div>
        </SectionCard>
      </Section>

      <Section>
        <SectionCard
          header={<CardTitle>Props</CardTitle>}
          contentClassName="p-6"
        >
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b">
                <th className="text-left py-2 font-semibold">Prop</th>
                <th className="text-left py-2 font-semibold">Type</th>
                <th className="text-left py-2 font-semibold">Default</th>
                <th className="text-left py-2 font-semibold">Description</th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">value</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">number</td>
                <td className="py-2 font-mono text-xs">0</td>
                <td className="py-2 text-muted-foreground">Progress value (0-100)</td>
              </tr>
              <tr className="border-b">
                <td className="py-2 font-mono text-xs">max</td>
                <td className="py-2 font-mono text-xs text-muted-foreground">number</td>
                <td className="py-2 font-mono text-xs">100</td>
                <td className="py-2 text-muted-foreground">Maximum value</td>
              </tr>
            </tbody>
          </table>
        </SectionCard>
      </Section>
    </>
  );
}
